import { RefObject, useEffect } from 'react';

export const useDetailsLeft = (
  open: boolean,
  locationDetailOption: unknown,
  focusTransferReference: RefObject<boolean>,
): void => {
  useEffect(() => {
    const detailsPanel = document.querySelector<HTMLElement>(
      '[data-testid="location-details-root"]',
    );
    if (!detailsPanel) return;

    const focusLeftList = () => {
      const openComboboxElement = document.querySelector<HTMLInputElement>(
        'input[role="combobox"][aria-expanded="true"]',
      );
      if (!openComboboxElement) {
        focusTransferReference.current = false;
        return;
      }

      openComboboxElement.focus();
      const activeOptionElement = document.querySelector<HTMLLIElement>(
        'li[role="option"].Mui-focused',
      );
      activeOptionElement?.scrollIntoView({ block: 'nearest' });

      document.addEventListener(
        'focusin',
        () => (focusTransferReference.current = false),
        { once: true, capture: true },
      );
    };

    const onDetailsArrowLeft = (event: KeyboardEvent) => {
      if (event.key !== 'ArrowLeft') return;
      event.preventDefault();
      focusTransferReference.current = true;
      requestAnimationFrame(focusLeftList);
    };

    detailsPanel.addEventListener('keydown', onDetailsArrowLeft, {
      capture: true,
    });
    return () => {
      detailsPanel.removeEventListener('keydown', onDetailsArrowLeft, {
        capture: true,
      });
    };
  }, [open, locationDetailOption, focusTransferReference]);
};
